module.exports = __webpack_public_path__ + "static/iso_14.4d6190c8.png";